import {forwardRef} from 'react';
import {assignInlineVars} from '@vanilla-extract/dynamic';
import cx from 'classnames';

import {theme} from '#theme';

import {Icon} from '../Icon';
import type {TextInputProps} from './TextInput.types';

import * as css from './TextInput.css';

export const TextInput = forwardRef(
  <T extends React.ElementType = 'input'>(
    {
      color,
      as,
      children,
      className,
      disabled = false,
      error = false,
      inputClassName,
      leftContent,
      leftIcon,
      rightContent,
      rightIcon,
      type,
      ...otherProps
    }: TextInputProps<T>,
    ref?: PolymorphicRef<T>,
  ) => {
    const Component = as || 'input';

    return (
      <div className={cx(css.rootStyles({disabled, error}), className)}>
        {leftContent && <div className={css.leftContent}>{leftContent}</div>}
        {leftIcon && (
          <Icon className={css.leftContent} color={color || 'dustyGray'} name={leftIcon} />
        )}

        <Component
          className={cx(inputClassName, css.inputStyles)}
          aria-invalid={error}
          disabled={disabled}
          ref={ref}
          type={type || 'text'}
          style={assignInlineVars({[css.colorVar]: theme.colors[color || 'mineShaft']})}
          {...otherProps}>
          {children}
        </Component>

        {rightIcon && (
          <Icon className={css.rightContent} color={color || 'silver'} name={rightIcon} />
        )}
        {rightContent && <div className={css.rightContent}>{rightContent}</div>}
      </div>
    );
  },
);
